import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import MapIcon from './MapIcon';
import AreaEditablePopup from '../areaEditablePopup/AreaEditablePopup';
import { AreaMapContainer } from './AreaDetail.css.js';
import map from 'static/images/map/map_png.png';

const AreaDetail = ({iconViewFlag, setIconViewFlag}) => {
  const [ popupOpen, setPopupOpen ] = useState(null);
  const [ selectedArea, setSelectedArea ] = useState({});
  const areas = useSelector(store => store.areas.area);

  // 지역 등록 팝업 오픈
  const areaInsertPopup = useCallback((e) => {
    e.preventDefault();
    setSelectedArea({ xcoordinate: e.nativeEvent.offsetX, ycoordinate: e.nativeEvent.offsetY });
    setPopupOpen(true);
  }, [])

  // 지역 정보 수정 팝업 오픈
  const areaEditPopup = useCallback((data) => {
    setSelectedArea(() => {
      return {
        ...data
      }
    });
    setPopupOpen(true);
  }, [])

  // 지역 정보 수정 팝업에서 위치 수정 버튼 클릭 시
  const positionChanger = useCallback(() => {
    setIconViewFlag(false);
    setPopupOpen(false);
  }, [])

  // 위치 수정 모드에서 새로운 위치를 클릭 시
  const selectNewArea = useCallback((e) => {
    if (iconViewFlag || Object.entries(selectedArea).length === 0) {
      return false;
    }
    
    const offsetX = e.nativeEvent.offsetX;
    const offsetY = e.nativeEvent.offsetY;
    
    setSelectedArea(selectedArea => {
      return {
        ...selectedArea,
        xcoordinate: offsetX,
        ycoordinate: offsetY
      }
    });

    setIconViewFlag(true);
    setPopupOpen(true);
  }, [iconViewFlag])

  return (
    <>
      <AreaMapContainer>
        { (areas && iconViewFlag) &&
          areas.map(data => {
            return (
              <MapIcon key={data.areaIdx}
                       fnAreaEdit={areaEditPopup}
                       area={data}/>
            )
          })
        }
        <img src={map} alt="map" onContextMenu={areaInsertPopup} onClick={selectNewArea} />
      </AreaMapContainer>
      
      <AreaEditablePopup selectedArea={selectedArea}
                         setSelectedArea={setSelectedArea}
                         positionChanger={positionChanger}
                         popupOpen={popupOpen} 
                         setPopupOpen={setPopupOpen} />
    </>
  )
}

export default AreaDetail;